import { PlanFeature } from '../enums/plan.enum';
const LITE_FEATURES = [PlanFeature.POS_BASIC, PlanFeature.INVENTORY, PlanFeature.CRM, PlanFeature.GOLD_PRICE, PlanFeature.BARCODE_PRINT];
const STARTER_FEATURES = [...LITE_FEATURES, PlanFeature.SCALE_DEVICE, PlanFeature.REPORT_BASIC, PlanFeature.E_INVOICE, PlanFeature.REFERRAL];
const PROFESSIONAL_FEATURES = [...STARTER_FEATURES, PlanFeature.MULTI_BRANCH, PlanFeature.MISA_SYNC, PlanFeature.REPORT_ADVANCED, PlanFeature.BULK_PRINT];
const ENTERPRISE_FEATURES = [...PROFESSIONAL_FEATURES, PlanFeature.API_ACCESS, PlanFeature.REPORT_CUSTOM, PlanFeature.SUPPORT_247];
export const PLAN_DEFINITIONS = {
  lite: {
    name: 'Lite',
    displayName: 'Gói Lite',
    slug: 'lite',
    tier: 1,
    limits: {
      maxStores: 1,
      maxUsers: 3,
      maxProducts: 500
    },
    features: LITE_FEATURES,
    pricing: {
      monthly: 199000,
      yearly: 1990000,
      currency: 'VND'
    },
    isActive: true,
    sortOrder: 1
  },
  starter: {
    name: 'Starter',
    displayName: 'Gói Starter',
    slug: 'starter',
    tier: 2,
    limits: {
      maxStores: 2,
      maxUsers: 8,
      maxProducts: 2000
    },
    features: STARTER_FEATURES,
    pricing: {
      monthly: 399000,
      yearly: 3990000,
      currency: 'VND'
    },
    isActive: true,
    sortOrder: 2
  },
  professional: {
    name: 'Professional',
    displayName: 'Gói Professional',
    slug: 'professional',
    tier: 3,
    limits: {
      maxStores: 5,
      maxUsers: 20,
      maxProducts: 10000
    },
    features: PROFESSIONAL_FEATURES,
    pricing: {
      monthly: 799000,
      yearly: 7990000,
      currency: 'VND'
    },
    isActive: true,
    sortOrder: 3
  },
  enterprise: {
    name: 'Enterprise',
    displayName: 'Gói Enterprise',
    slug: 'enterprise',
    tier: 4,
    limits: {
      maxStores: null,
      maxUsers: null,
      maxProducts: null
    },
    features: ENTERPRISE_FEATURES,
    pricing: {
      monthly: 1500000,
      yearly: 15000000,
      currency: 'VND'
    },
    isActive: true,
    sortOrder: 4
  }
};
//# sourceMappingURL=plans.js.map